// Those functions are executed at runtime
// Once the ajv2019 experiment is merged,
// we should make the changes in the schemas and remove them

import _ from 'lodash'
import type {SchemaFile} from '@wix/document-services-types'
import {walk} from '../../build/json-walker'

function convertToUnevaluatedForRemovalInstance(schema: SchemaFile): SchemaFile {
    return walk(
        {
            oneOf: (value: any, key: string, parentNode: any) => {
                parentNode.unevaluatedProperties = true
                _.forEach(value, (item: any) => {
                    if (_.has(item, ['additionalProperties'])) {
                        delete item.additionalProperties
                    }
                })
            },
            anyOf: (value: any, key: string, parentNode: any) => {
                parentNode.unevaluatedProperties = false
                _.forEach(value, (item: any) => {
                    if (_.has(item, ['additionalProperties'])) {
                        delete item.additionalProperties
                    }
                })
            }
        },
        schema,
        {}
    ) as SchemaFile
}

export {convertToUnevaluatedForRemovalInstance}
